<template>
    <div class="md-layout">
        <div class="md-layout-item md-small-size-100">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="card-icon">
                        <md-icon>Activity</md-icon>
                    </div>
                    <h4 class="title">Add Activity</h4>
                </md-card-header>

                <form @submit.prevent="add">
                    <md-card-content>
                        <div class="text-right">
                            <md-button @click="goBack" class="md-primary md-dense">
                                Back to List
                            </md-button>
                        </div>

                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Name
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="activity.name"/>
                                    <validation-error :errors="apiValidationErrors.name"/>
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Description
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
<!--                                    <md-input v-model="activity.description"/>-->
                                    <ckeditor
                                            :editor="editor"
                                            v-model="activity.description"
                                            :config="editorConfig"
                                    ></ckeditor>
                                    <validation-error :errors="apiValidationErrors.description"/>
                                </md-field>
                            </div>
                        </div>
                        <select-input-horizontal
                                v-model="activity.payment_mode"
                                :options="paymentsMode"
                                placeholder="Select Payment Mode"
                                label="Payment Mode"
                                name="name"
                                track-by="name"
                                main-class="md-layout"
                                :allow-empty="false"
                                deselect-label="Can't remove"
                                label-class="md-layout-item md-size-25 md-form-label"
                                :error="apiValidationErrors.payment_mode"
                        ></select-input-horizontal>
<!--                        <select-input-horizontal-->
<!--                                v-model="activity.pay_code"-->
<!--                                :options="paymentsMode"-->
<!--                                placeholder="Select Payment Code"-->
<!--                                label="Payment Code"-->
<!--                                name="code"-->
<!--                                track-by="code"-->
<!--                                main-class="md-layout"-->
<!--                                :allow-empty="false"-->
<!--                                deselect-label="Can't remove"-->
<!--                                label-class="md-layout-item md-size-25 md-form-label"-->
<!--                                :error="apiValidationErrors.payment_code"-->
<!--                        ></select-input-horizontal>-->
                        <select-input-horizontal
                                v-model="activity.category_id"
                                :options="available_category_dropdown"
                                placeholder="Select Activity"
                                label="Activity Category"
                                name="name"
                                track-by="id"
                                main-class="md-layout"
                                :allow-empty="false"
                                deselect-label="Can't remove"
                                label-class="md-layout-item md-size-25 md-form-label"
                                :error="apiValidationErrors.category_id"
                        ></select-input-horizontal>

                    </md-card-content>

                    <md-card-actions md-alignment="right">
                        <md-button type="submit" class="md-success">Add Activity</md-button>
                    </md-card-actions>
                </form>
            </md-card>
        </div>
    </div>
</template>
<script>
import { ValidationError } from '@/components';
import formMixin from '@/mixins/form-mixin';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import CKEditor from '@ckeditor/ckeditor5-vue';
import SelectInputHorizontal from '../../../components/Inputs/SelectInputHorizontal';

export default {
    components: { SelectInputHorizontal,ValidationError, ckeditor: CKEditor.component },

    mixins: [formMixin],

    data: () => ({
        editor: ClassicEditor,
        editorConfig: {
            toolbar: [
                'heading',
                '|',
                'bold',
                'italic',
                'link',
                'bulletedList',
                'numberedList',
                'blockQuote',
                'Outdent',
                'Indent',
                'TextColor',
                'BGColor',
            ],
        },
        paymentsMode: [
            { id: 'Per TEUs', 'name': 'Per TEUs', code: 'TU' },
            { id: 'Per Unit', 'name': 'Per Unit', code: 'PU' },
            { id: 'Per Man Hour', 'name': 'Per Man Hour', code: 'MH' },
            { id: 'Per Tonne', 'name': 'Per Tonne', code: 'PT' },
        ],
        activity: {
            type: 'activities',
            name: null,
            description: null,
            payment_mode: null,
            pay_code: null,
            category_id: null,
        },
        available_category_dropdown: [],
        category_dropdown: [],
    }),
    created () {
        this.getCategoryDropDowns();
    },
    methods: {
        async add () {
            try {
                await this.$store.dispatch('activities/add', this.activity);
                this.notifySuccess('Activity added successfully.');
                this.goBack();
            } catch (e) {
                if (e.response.data.errors[0]) {
                    await this.notifyError(e.response.data.errors[0].title);
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.notifyError('Oops, something went wrong!');
                }
            }
        },
        getCategoryDropDowns () {
            this.$store.dispatch('categories/list').then(() => {
                this.available_category_dropdown = this.$store.getters['categories/dropdown'];
                if (this.available_category_dropdown && this.available_category_dropdown.length) {
                    this.activity.category_id = this.available_category_dropdown[0].id;
                }
            });
        },
        goBack () {
            this.$router.push({ name: 'Activities List' });
        },
    },
    computed:{
        mode () {
            return this.activity.payment_mode;
        }
    },
    watch:{
        mode () {
            let modes =   this.paymentsMode.find(m => m.id === this.activity.payment_mode);
            this.activity.pay_code = modes.code;
        }
    }
};
</script>
